import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"

type FilteredParams = {
  DateFrom: string
  DateEnd: string
  Approval?: string
  Delivery?: string
  VendorID: number
  po?: string
  status?: string
  bill?: string
}

type DataTypeKey = "purchase" | "bill" | "deposit" | "reject" | "payment"

const urlMap: Record<DataTypeKey, string> = {
  purchase: "/purchaseorder/getdata_by_vendor",
  bill: "/probill/getdata_by_vendor",
  deposit: "/depositvendor/getdata",
  reject: "/proreject/getdata_by_vendor",
  payment: "/paymentbill/getdata_by_vendor",
}

export function useListDataPost<T>(type: DataTypeKey, filters: FilteredParams) {
  const api = useApi()
  const [data, setData] = useState<T[]>([])
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | undefined } = {}
  if (filters.DateFrom) params.DateFrom = filters.DateFrom
  if (filters.DateEnd) params.DateEnd = filters.DateEnd
  if (filters.Approval) params.Approval = filters.Approval
  if (filters.Delivery) params.Delivered = filters.Delivery
  if (filters.VendorID) params.VendorID = filters.VendorID
  if (filters.po) params.PurchaseOrderID = filters.po
  if (filters.status) params.status = filters.status
  if (filters.bill) params.BillID = filters.bill
  const url = urlMap[type]

  const fetchData = () => {
    setLoading(true)
    api
      .post(url, null, {params})
      .then((res: SuccessFetch<{ payload: T[] }>) => setData(res.data.payload))
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchData()
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [
      type, 
      filters.DateFrom, 
      filters.DateEnd, 
      filters.Approval, 
      filters.Delivery, 
      filters.VendorID, 
      filters.po, 
      filters.status, 
      filters.bill
    ])

  const refetch = () => fetchData()

  return { data, isLoading, refetch }
}



